<template>
  <div
    class="sidebar-menu z-10 h-screen"
    :class="{
      'w-60': !zoom,
      'w-16': zoom
    }"
  >
    <div
      class="h-full bg-cdp-white shadow-md"
      :class="{
        'w-52': !zoom,
        'w-16': zoom
      }"
    >
      <Sidebar-Menu
        :menu="menuLists[currenArea]"
        :collapsed="zoom"
        :show-one-child="true"
        :hide-toggle="true"
        width="210px"
        :class="{
          'w-52': !zoom,
          'w-16': zoom
        }"
      >
        <template #header>
          <div
            class="flex cursor-pointer p-4 hover:bg-gray-200"
            :class="{
              'w-52 items-center pl-4': !zoom,
              'w-16 w-full justify-center': zoom
            }"
            @click="zoom = !zoom"
          >
            <icon
              v-show="!zoom"
              name="ic_common_arrow02_left"
              class="h-4 w-4 text-cdp-main-primary-dark"
            />
            <icon
              v-show="zoom"
              name="ic_common_arrow02_right"
              class="h-4 w-4 text-cdp-main-primary-dark"
            />
            <span v-show="!zoom" class="ml-3 text-sm text-cdp-main-primary-dark">
              {{ t('zoom_feature_directory') }}
            </span>
          </div>
        </template>
      </Sidebar-Menu>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

import { storeToRefs } from 'pinia';
import { userStore } from '@/stores/user.js';
import { routerStore } from '@/stores/route.js';
import { permissionStore } from '@/stores/permission.js';

import { breakpoints } from '@/composables/breakpoints.js';

import { SidebarMenu } from 'vue-sidebar-menu';
import { ref, toRaw, computed, watch, onBeforeMount } from 'vue';
export default {
  name: 'NavBar',
  components: {
    SidebarMenu
  },
  setup() {
    const { t } = useI18n();
    const zoom = ref(false);
    const storeUser = userStore();
    const storeRoute = routerStore();
    const storePermission = permissionStore();

    const { allRoute, getDashboard } = storeRoute;

    const { currenArea } = storeToRefs(storeUser);

    const { dashboardMap } = storeToRefs(storeRoute);

    const { permission } = storeToRefs(storePermission);

    const menuLists = computed(() => {
      const result = {};
      allRoute.forEach((mother) => {
        result[mother?.meta.key] = [];
        // insert hint before start
        if (mother?.meta?.hint) {
          result[mother?.meta.key].push({
            header: t(`route.${mother?.meta?.hint}`),
            hiddenOnCollapse: true
          });
        }

        // leval 1 route
        mother?.children.forEach((child) => {
          if (child?.meta?.hidden) {
            return;
          }
          let obj = {};
          if (checkPermission(child.meta.permission)) {
            obj = {
              exact: true,
              title: t(`route.${child.name}`),
              icon: {
                element: 'icon',
                class: 'justify-center ml-2',
                attributes: {
                  name: child?.icon
                }
              }
            };

            // when there is no child route, the parent route will replace it
            if (child?.path && !child?.children) {
              obj.href = child?.path;
            }

            // level 2 route
            if (child?.children) {
              obj.child = [];

              child?.children.forEach((child2) => {
                obj.child.push({
                  href: child2?.path,
                  title: t(`route.${child2?.name}`)
                });
              });

              if (child?.name === 'dashboard') {
                obj.child = dashboardMap.value;
              }
            }
            result[mother?.meta.key].push(obj);
          }
        });
      });
      return result;
    });

    watch(
      () => breakpoints,
      (point) => {
        checkZoom(point);
      },
      { deep: true },
      { immediate: false }
    );

    watch(
      () => permission.value,
      (newPermission, oldPermission) => {
        if (newPermission?.dashboard?.retrieve !== oldPermission?.dashboard?.retrieve) {
          if (newPermission?.dashboard?.retrieve) {
            getDashboard();
          }
        }
      }
    );

    onBeforeMount(() => {
      checkZoom(breakpoints);
    });

    function checkZoom(point) {
      if (point.lg || point.xl || point.xxl) {
        zoom.value = false;
      } else {
        zoom.value = true;
      }
    }

    function checkPermission(routeKeys) {
      if (breakpoints) {
        return routeKeys.every((key) => toRaw(permission.value[key])?.retrieve);
      } else {
        return true;
      }
    }

    return {
      t,
      zoom,
      menuLists,
      currenArea
    };
  }
};
</script>